module.exports = __webpack_public_path__ + "img/homepage-sample.c12010cb.jpg";